export const monedaRoutesMap = {
  gestion: {
    path: '/moneda/gestion',
    name: 'Moneda de Venta',
  },
  tienda: {
    path: '/moneda/monedaTienda',
    name: 'Moneda de Tienda',
  },
}
